<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.overviews') }} > {{ $t('sidebar.todoinventory') }}
          </div>
        </div>
      </div>
    </div>
    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <div
        v-if="ready && todo.length > 0"
        class="col-md-12 no-padding no-margin row">
        <div
          v-for="(item, index) in todo"
          class="col-md-12 col-lg-12">
          <div class="col-lg-6 card">
            <section-title
              :title="item.warehouse.warehouse_name"
              fontweight="bold"/>
            <div class="col-md-12 no-padding no-margin row">
              <div class="col-md-4 mb-2 no-padding">
                <p>{{ $t('message.receiptsorders') }}</p>
                <template>
                  <router-link
                    v-if="item.goodsreceipt.todo > 0"
                    :to="{
                      name: 'GoodsReceiptAll',
                      query: {
                        page: 1,
                        wh: item.warehouse.warehouse_id,
                        status: 'padding'
                      }
                    }"
                    class="btn btn-web btn-sm"
                  >
                    {{ item.goodsreceipt.todo }}
                    {{ $t('message.toprocess') }}
                  </router-link>
                  <span v-else>-</span>
                </template>
              </div>
              <div class="col-md-4 mb-2 no-padding">
                <p>{{ $t('message.deliveryorders') }}</p>
                <template>
                  <router-link
                    v-if="item.goodsissue.todo"
                    :to="{
                      name: 'GoodsIssueAll',
                      query: {
                        page: 1,
                        wh: item.warehouse.warehouse_id,
                        status: 'padding'
                      }
                    }"
                    class="btn btn-web btn-sm"
                  >
                    {{ item.goodsissue.todo }}
                    {{ $t('message.toprocess') }}
                  </router-link>
                  <span v-else>-</span>
                </template>
              </div>
              <div class="col-md-4 mb-2 no-padding">
                <p>{{ $t('message.transferorders') }}</p>
                <template>
                  <router-link
                    v-if="item.goodstransfer.todo"
                    :to="{
                      name: 'GoodsTransferAll',
                      query: {
                        page: 1,
                        wh: item.warehouse.warehouse_id,
                        status: 'padding'
                      }
                    }"
                    class="btn btn-web btn-sm"
                  >
                    {{ item.goodstransfer.todo }}
                    {{ $t('message.toprocess') }}
                  </router-link>
                  <span v-else>-</span>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'

export default {
  name: 'InventoryTodo',
  data () {
    return {
      ready: false,
    }
  },
  computed: mapGetters({
    activities: 'getActivities',
    warehouses: 'getWarehouses',
    sidebar: 'getSidebar',
    todo: 'getTodo',
  }),
  watch: {
    ready: function () {
      // finish loading
      this.showFinish(this.$Progress)
    },
    warehouses: function (newVal, oldVal) {
      sidebarModule.init(this.getObject(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.active({
        sidebarAtIdx: 0,
        submenuAtIdx: 0,
      })
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    this.$store.dispatch('getWarehouses')
    await this.$store.dispatch('getTodo')
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 1,
      },
    })
    // set sidebar stockcontrols ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
    sidebarModule.active({
      sidebarAtIdx: 0,
      submenuAtIdx: 0,
    })
  },
  mounted: function () {

  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearTodo'])
  },
  methods: {

  },
}
</script>

<style scoped>
  #content .content {
    padding-top: 18px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .card {
    background: #FFF;
    border: solid 1px #D8E2E7;
    border-radius: 2px;
    padding: 15px 15px 7px 15px;
    margin: 10px 0 15px 0;
  }
  .card p {
    margin: 0 0 5px 0;
  }
  .btn-web {
    min-width: 92px;
  }
  @media (max-width: 575.98px) {
    .btn-web {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/inventory/overview/Todo.vue